<div *ngIf="warningMessage" class="message-container">
    <p><strong>Warning - </strong>{{warningMessage}}</p>
    <p-button label="Close" (onClick)="removeMessage()"></p-button>
</div>

